module.exports = __webpack_public_path__ + "img/logo.c750579.png";